<template>
  <div class="previewScreenshotRootBox" id="previewScreenshot" v-if="visible">
    <div class="previewScreenshotContentBox">
      <div class="rect"
           :style="time>5 && time<=10?{left: '30px',top: '65px',height:'258px',width: '318px'}:time>10 && time<=15?{left: '450px',top: '448px',width:'60px'}:null">
        <div class="numTime">{{ time / 5 }}</div>
      </div>
      <el-image src="static/images/IT/screenshot_tip.png" style="width: 600px;height: 500px"></el-image>
      <i class="el-icon-circle-close" title="关闭" @click="close"></i>
      <span class="tip">{{ tip }}</span>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: "previewScreenshot",
  data() {
    return {
      time: 5,
      intervalId: null,
      visible: false,
      tip: '',
      onClose: null
    }
  },
  beforeDestroy() {
    this.close()
  },
  methods: {
    show(msg, ok) {
      this.onClose = ok
      this.tip = msg
      this.visible = true
      this.play()
      return {close: this.close}
    },
    play() {
      this.$nextTick(() => {
        this.intervalId = setInterval(() => {
          if (this.time > 10) {
            this.time = 5
          } else {
            this.time += 5
          }
        }, 2000)
      })
    },
    close() {
      clearInterval(this.intervalId)
      this.time = 5
      this.visible = false
      if (typeof this.onClose === 'function') {
        this.onClose()
      }
      return {close: this.show}
    },
  }
}
</script>

<style scoped lang="scss">
.previewScreenshotRootBox {
  width: 100vw;
  height: 100vh;
  display: inline-flex;
  background-color: rgba(204, 204, 204, 0.43);
  position: absolute;
  right: 0;
  top: 0;
  padding: 2px;
  box-sizing: border-box;
  box-shadow: 0 0 5px #cccccc;
  backdrop-filter: blur(15px);
  pointer-events: auto;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 999999;

  .previewScreenshotContentBox {
    position: absolute;
    pointer-events: auto;
    width: 600px;
    height: 500px;

    & > span.tip {
      position: absolute;
      left: 26px;
      bottom: 26px;
      color: #ea6d6d;
      animation:1s tip infinite linear alternate;
    }

    .el-icon-circle-close {
      padding: 5px;
      position: absolute;
      z-index: 9;
      bottom: -70px;
      left: 50%;
      font-size: 46px;
      cursor: pointer;
      border-radius: 50%;
      color: #3e3e3e;
      user-select: none;
      transform: translateX(-50%);
      transition: .5s;
    }

    .el-icon-circle-close:hover {
      color: #f85d5d;
    }

    .rect {
      z-index: 8;
      left: 10px;
      top: 7px;
      position: absolute;
      display: inline-flex;
      border: 4px solid #f85d5d;
      align-items: center;
      justify-content: end;
      width: 146px;
      height: 32px;
      animation: tip infinite 1s;
      border-radius: 4px;
      //animation-iteration-count: infinite;
      .numTime {
        position: absolute;
        left: -40px;
        width: 30px;
        height: 30px;
        background: #f8b030;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 1.5em;
        margin-right: 10px
      }
    }
  }
}

@keyframes tip {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/teachingDetail/list/classroom/previewScreenshot.vue